/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  profile: 'Profile',
  settings: 'Réglages',
  name: 'Nom',
  email: 'E-mail',
  password: 'Mot de passe',
  passwordConfirmation: 'Confirmation mot de passe',
  locale: 'Traduction',
  view: 'Vue',
  comfortable: 'Comfortable',
  compact: 'Compact',
  line: 'Ligne',
  full: 'Plein',
  narrow: 'Étroit',
  sort: 'Sort',
  lastModifiedFirst: 'Dernière modification en premier',
  lastCreatedFirst: 'Dernier créé en premier',
  alphabetically: 'Alphabétiquement',
  theme: 'Thème',
  dark: 'sombre',
  light: 'Clair',
  save: 'Sauver',
  saveSuccess: 'Profil enregistré avec succès.',
  saveFailure: 'Le profil n\'a pas pu être enregistré.',
  fetchFailure: 'Impossible de récupérer le profil.',
  application: 'Application',
  install: 'Installer',
  youCanInstallPlainpad: 'Vous pouvez installer Plainpad et y accéder directement depuis la machine hôte.',
  invalidateCache: 'Invalider le cache',
  encrypt: 'Chiffrer',
  yes: 'Oui',
  no: 'Non',
  passwordsMismatch: 'Les mots de passe fournis ne correspondent pas, veuillez réessayer.',
  invalidateCachePrompt: 'Êtes-vous sûr de vouloir invalider le cache local ? Les informations non synchronisées seront perdues.'
}
